import { clearUser } from '@Pages/Profile/profileSlice';
import { Tokens } from '../constants/common';
import { AppDispatch, RootState, useAppSelector } from '../store/store';

import { baseApi } from '@Services/api';


export const onLogout = async (dispatch:AppDispatch) => {
  localStorage.removeItem('access_token'); // or Tokens.ACCESS_TOKEN
  localStorage.removeItem('refresh_token'); // or Tokens.REFRESH_TOKEN

  dispatch(clearUser()); // Reset user state
  dispatch(baseApi.util.resetApiState()); // Reset RTK Query cache

};


export const formatTimestampDifference = (timestampString: string) => {
  // Convert timestamp string to a Date object
  const timestamp = new Date(timestampString);

  // Get the current time in milliseconds
  const currentTime = new Date().getTime();

  // Calculate the time difference in milliseconds
  const timeDifference = currentTime - timestamp.getTime();

  // Function to convert milliseconds to hours
  const millisecondsToHours = (ms: number) => {
    return ms / (1000 * 60 * 60);
  };

  // Function to convert milliseconds to days
  const millisecondsToDays = (ms: number) => {
    return ms / (1000 * 60 * 60 * 24);
  };

  // Function to convert milliseconds to months
  const millisecondsToMonths = (ms: number) => {
    return ms / (1000 * 60 * 60 * 24 * 30); // Approximation
  };

  // Format the time difference based on the duration
  const formatTimeDifference = (difference: number) => {
    if (difference < 1) {
      return "Just now";
    } else if (difference < 24) {
      return `${Math.floor(difference)} hours ago`;
    } else if (difference < 30) {
      return `${Math.floor(difference / 24)} days ago`;
    } else {
      const formattedDate = timestamp.toLocaleDateString("en-GB");
      return formattedDate;
    }
  };

  // Calculate the difference in hours, days, and months
  const differenceInHours = millisecondsToHours(timeDifference);
  const differenceInDays = millisecondsToDays(timeDifference);
  const differenceInMonths = millisecondsToMonths(timeDifference);

  // Format the time difference
  const formattedTimeDifference = formatTimeDifference(differenceInHours);

  return formattedTimeDifference;
}


export const getReferralIdFromCookie = () => {
  const name = 'lprefid=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return null;
}

export const validateUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};


export const getUtmParamsFromCookies = (): { [key: string]: string } => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');
  const utmParams: { [key: string]: string } = {};

  cookies.forEach(cookie => {
    const [key, value] = cookie.trim().split('=');
    if (key.toLowerCase().startsWith('utm_')) {
      utmParams[key.toLowerCase()] = value;
    }
  });

  return utmParams;
};


export const deleteUTMCookies = () => {
  const cookies = document.cookie.split(';');
  const currentHost = window.location.hostname;
  const isLocalhost = currentHost === 'localhost' || currentHost === '127.0.0.1';
  const COOKIE_PATH = '/';
  const COOKIE_DOMAIN = isLocalhost ? '' : '.linkplease.co';

  cookies.forEach(cookie => {
    const [rawName] = cookie.split('=');
    const name = rawName.trim();

    if (name.startsWith('utm_')) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${COOKIE_PATH}${COOKIE_DOMAIN ? `; domain=${COOKIE_DOMAIN}` : ''
        }; SameSite=Lax`;
    }
  });

  console.log("UTM values removed")
};


export const CheckPasswordStrength = (password: string) => {
        const minLength = 8;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumbers = /\d/.test(password);
        const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        if (
            password.length >= minLength &&
            hasUpperCase &&
            hasLowerCase &&
            hasNumbers &&
            hasSpecialChars
        ) {
            return true;
        } else {
            return false;
        }
    }

export const textToBytes = (data:string) => {
  const encoder = new TextEncoder(); // UTF-8 by default
  const encoded = encoder.encode(data);
  return encoded
}